var _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoOutdent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.9,11.93H39.99c1.11,0,2-.89,2-2s-.89-2-2-2H7.9c-1.11,0-2,.89-2,2s.89,2,2,2Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.99,36.07H7.9c-1.11,0-2,.89-2,2s.89,2,2,2H39.99c1.11,0,2-.89,2-2s-.89-2-2-2Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.99,22.11h-14.1c-1.11,0-2,.89-2,2s.89,2,2,2h14.1c1.11,0,2-.89,2-2s-.89-2-2-2Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8,25.7l9.25,5.34c.31,.18,.65,.27,1,.27s.69-.09,1-.27c.62-.36,1-1.02,1-1.73v-10.68c0-.71-.38-1.38-1-1.73-.62-.36-1.38-.36-2,0l-9.25,5.34c-.62,.36-1,1.02-1,1.73s.38,1.38,1,1.73Z",
    fill: outlineColor
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.1,
    width: 48,
    height: 48,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoOutdent);
export default __webpack_public_path__ + "static/media/ico-outdent.b2d8b159fc1af9c503ccb7bfe8a26af2.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = false;